import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetTitle,
} from '@/components/ModalSheet'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/Table'
import { Button } from '@/components/Button'
import styles from './ServiceItemListDialog.module.css'
import { isNotNil } from '@/utils/object-util'
import { formatMoney } from '@/utils/money-util'
import { type ServiceItem } from '@/features/jobs/details/components/ServiceItemListDialog/ServiceItemListDialogViewModel'

export interface ServiceItemListDialogProps {
  showing: boolean
  serviceItems: ServiceItem[]
  canSeePriceAsAdmin: boolean
  canSeeProPayoutAsAdmin: boolean
  onClose: () => unknown
}

export function ServiceItemListDialog({
  showing,
  serviceItems,
  canSeePriceAsAdmin,
  canSeeProPayoutAsAdmin,
  onClose,
}: ServiceItemListDialogProps) {
  return (
    <ModalSheet showing={showing} onRequestClose={onClose}>
      <ModalSheetHeader bordered withCloseButton>
        <ModalSheetTitle>
          Service items
          <span className={styles.titleSubtext}>
            {` (${serviceItems.length})`}
          </span>
        </ModalSheetTitle>
      </ModalSheetHeader>
      <ModalSheetContent>
        <Table>
          <TableHead>
            <TableHeader align="left">Name</TableHeader>
            {canSeePriceAsAdmin && (
              <TableHeader align="center">Price</TableHeader>
            )}
            {canSeeProPayoutAsAdmin && (
              <TableHeader align="center">Payout</TableHeader>
            )}
            {canSeePriceAsAdmin && (
              <TableHeader align="center">Courtesy</TableHeader>
            )}
            <TableHeader align="center">Quantity</TableHeader>
          </TableHead>
          <TableBody>
            {serviceItems.map((item, index) => (
              <ServiceItemRow
                item={item}
                key={index}
                canSeePriceAsAdmin={canSeePriceAsAdmin}
                canSeeProPayoutAsAdmin={canSeeProPayoutAsAdmin}
              />
            ))}
          </TableBody>
        </Table>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Close" variant="default" onPress={onClose} />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}

interface ServiceItemRowProps {
  item: ServiceItem
  canSeePriceAsAdmin: boolean
  canSeeProPayoutAsAdmin: boolean
}

function ServiceItemRow({
  item,
  canSeePriceAsAdmin,
  canSeeProPayoutAsAdmin,
}: ServiceItemRowProps) {
  return (
    <TableRow>
      <TableCell align="left">{item.name}</TableCell>
      {canSeePriceAsAdmin && (
        <TableCell align="center">
          {isNotNil(item.clientPrice) ? formatMoney(item.clientPrice) : ''}
        </TableCell>
      )}
      {canSeeProPayoutAsAdmin && (
        <TableCell align="center">
          {isNotNil(item.proPrice) ? formatMoney(item.proPrice) : ''}
        </TableCell>
      )}
      {canSeePriceAsAdmin && (
        <TableCell align="center">
          {isNotNil(item.courtesyQuantity) ? item.courtesyQuantity : ''}
        </TableCell>
      )}
      <TableCell width={100} align="center">
        {item.quantity}
      </TableCell>
    </TableRow>
  )
}
